// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}
ion-menu ion-content ion-list {
  background-color: transparent;
  padding-bottom: 32px;
  padding-top: 16px;
}

ion-menu.ios .menu-item ion-icon {
  font-size: 32px;
  text-shadow: 6px 2px 12px rgba(0, 0, 0, 0.12), -4px -2px 8px rgb(255, 255, 255);
  color: var(--ion-background-color);
}

ion-split-pane {
  --border: none;
}

.menu-item {
  text-decoration: none;
  display: flex;
  align-items: center;
  margin-top: 16px;
}
.menu-item span {
  font-weight: 800;
  font-size: 2.5rem;
  color: var(--ion-color-dark);
  text-shadow: var(--neumorphic-text-shadow);
  outline: none;
}
.menu-item span .underline {
  box-shadow: var(--neumorphic-box-shadow);
  width: 100%;
  height: 10px;
  border-radius: 16px;
  display: none;
}

.menu-item.selected span .underline {
  display: block;
}

.logo-container {
  filter: var(--neumorphic-svg-mask-shadow);
  margin-top: 4vw;
  margin-left: 32px;
}

.side-menu-logo {
  line-height: 0;
  display: block;
  height: 80px;
  background-color: var(--ion-color-dark);
  -webkit-mask: url("/assets/brand/logo.svg") no-repeat left;
          mask: url("/assets/brand/logo.svg") no-repeat left;
}

ion-menu::part(backdrop) {
  opacity: 0;
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAGA;EACE,2EAAA;AADF;AAEE;EACE,6BAAA;EACA,oBAAA;EACA,iBAAA;AAAJ;;AAgCA;EACE,eAAA;EACA,+EAAA;EAEA,kCAAA;AA9BF;;AAiFA;EACE,cAAA;AA9EF;;AAiFA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA9EF;AAgFE;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,0CAAA;EACA,aAAA;AA9EJ;AA+EI;EACE,wCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AA7EN;;AAoFK;EACE,cAAA;AAjFP;;AAiGA;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;AA9FF;;AAgGA;EACE,cAAA;EACA,cAAA;EAEA,YAAA;EACA,uCAAA;EAEA,0DAAA;UAAA,kDAAA;AA/FF;;AAkGA;EACE,UAAA;EACA,6BAAA;AA/FF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap\");\n\n\nion-menu ion-content {\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\n  ion-list{\n    background-color: transparent;\n    padding-bottom: 32px;\n    padding-top: 16px;\n\n  }\n}\n\n\n\n\n\n\n\n\n// ion-menu.ios ion-note {\n//   line-height: 24px;\n//   margin-bottom: 20px;\n// }\n\n// ion-menu.ios ion-item {\n//   display: inline-block;\n//   --padding-start: 16px;\n//   --padding-end: 16px;\n//   --min-height: 32px;\n//   margin: 8px;\n\n//   // font-weight: 600;\n// }\n\n// ion-menu.ios ion-item.selected ion-icon {\n//   color: var(--ion-color-secondary);\n\n// }\n\nion-menu.ios .menu-item ion-icon {\n  font-size: 32px;\n  text-shadow:6px 2px 12px rgba(0, 0, 0, 0.12), -4px -2px 8px rgba(255, 255, 255, 1);\n\n  color: var(--ion-background-color);\n\n  // color: #73849a;\n}\n\n// ion-menu.ios ion-list#labels-list ion-list-header {\n//   margin-bottom: 8px;\n// }\n\n// ion-menu.ios ion-list-header,\n// ion-menu.ios ion-note {\n//   padding-left: 16px;\n//   padding-right: 16px;\n// }\n\n// ion-menu.ios ion-note {\n//   margin-bottom: 8px;\n// }\n\n// ion-note {\n//   display: inline-block;\n//   font-size: 16px;\n\n//   color: var(--ion-color-medium-shade);\n// }\n\n// ion-item.selected {\n//   --color: var(--ion-color-secondary);\n//   p{\n//     // text-shadow: inset 4px 2px 4px rgba(0, 0, 0, 0.12), inset -4px -2px 4px rgba(255, 255, 255, 1);\n//     // font: bold 200px arial, sans-serif;\n// background-color: var(--ion-color-primary);\n// color: transparent;\n// text-shadow: 2px 1px 4px rgba(0, 0, 0, 0.12);\n// -webkit-background-clip: text;\n//     -moz-background-clip: text;\n//   background-clip: text;\n// }\n\n\n  // &active{\n  //   box-shadow: inset 4px 2px 16px rgba(0, 0, 0, 0.12), inset -4px -2px 16px rgba(255, 255, 255, 1) ;\n\n  // }\n// }\n\n// ion-item:active{\n//   box-shadow: inset 4px 2px 16px rgba(0, 0, 0, 0.12), inset -4px -2px 16px rgba(255, 255, 255, 1) ;\n\n// }\n\nion-split-pane{\n  --border: none;\n}\n\n.menu-item{\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n\n  span{\n    font-weight: 800;\n    font-size: 2.5rem;\n    color: var(--ion-color-dark);\n    text-shadow:var(--neumorphic-text-shadow);\n    outline: none;\n    .underline{\n      box-shadow: var(--neumorphic-box-shadow) ;\n      width: 100%;\n      height: 10px;\n      border-radius: 16px;\n      display: none;\n    }\n  }\n}\n\n.menu-item.selected{\n   span{\n     .underline{\n       display: block;\n     }\n   }\n}\n\n\n.card{\n  // height: 92%;\n  // margin: 4vw;\n  // border-radius: 16px;\n  // box-shadow: 4px 2px 16px rgba(0, 0, 0, 0.12), -4px -2px 16px rgba(255, 255, 255, 1) ;\n  // background-color: red;\n  // border: 2px solid red;\n\n}\n\n.logo-container{\n  filter: var(--neumorphic-svg-mask-shadow) ;\n  margin-top: 4vw;\n  margin-left: 32px;\n}\n.side-menu-logo{\n  line-height: 0;\n  display: block;\n  // width: 120px;\n  height: 80px;\n  background-color: var(--ion-color-dark);\n\n  mask: url(\"/assets/brand/logo.svg\") no-repeat left\n}\n\nion-menu::part(backdrop){\n  opacity: 0;\n  background-color: transparent;\n}\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
